export const FANART_TV_API_KEY = "385023c5d2318b841301d515c2d4b5aa";
export const SENTRY_URL = "https://f1111a78def54fc1a8818d300f4b7032@o1052588.ingest.sentry.io/6036369";
